import { getCurrentScriptChartUrl } from './utils'

let data = {}

const envData = {
  get analyticsKey () { return data.analyticsKey },
  get androidCallbackUrl () { return data.androidCallbackUrl },
  get apiUrl () { return data.apiUrl },
  get authAudience () { return data.authAudience },
  get authClientId () { return data.authClientId },
  get authCookie () { return data.authCookie },
  get authCustomClaimNamespace () { return data.authCustomClaimNamespace },
  get authHostname () { return data.authHostname },
  get browserExtensionId () { return data.browserExtensionId },
  get browserExtensionUrl () { return data.browserExtensionUrl },
  get cloud8Url () { return data.cloud8Url },
  get chaletUrl () { return data.chaletUrl },
  get cloudflareApiUrl () { return data.cloudflareApiUrl },
  get conferenceMapperUrl () { return data.conferenceMapperUrl },
  get corsProxyUrl () { return data.corsProxyUrl },
  get env () { return data.env },
  get feedbackUrl () { return data.feedbackUrl },
  get jaasUrl () { return data.jaasUrl },
  get ldApiKey () { return data.ldApiKey },
  get officePluginUrl () { return data.officePluginUrl },
  get stripeKey () { return data.stripeKey },
  get videoElevationAppId () { return data.videoElevationAppId },
  get vmmsUrl () { return data.vmmsUrl },
  get webUrl () { return data.webUrl },
  get appStoreBaseUrl () { return data.appStoreBaseUrl },
  get meetMetricsAppId () { return data.meetMetricsAppId },
  get meetMetricsApiUrl () { return data.meetMetricsApiUrl }
}

export const getEnvironmentData = async ({ hostname } = {}) => {
  const baseUrl = hostname || getCurrentScriptChartUrl()
  const response = await fetch(`${baseUrl}/env`)

  data = await response.json()

  return data
}

export default envData
